// theme/colors.js
export const colors = {
  brand: {
    blush: "#FAEDE7",
    sand: "#D1B7A1",
    gold: "#C9A24D",
    goldDark: "#A67C2D",
    goldLight: "#EBD9A6",
  },

  text: {
    heading: "#3A2F2A",
    body: "#6B5E55",
    muted: "#9A8F86",
  },

  ui: {
    border: "#E7D9CF",
    surface: "#FFFFFF",
  },
};
